export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_f79f9b78-9c25-4a8e-b2ab-0ba9f9c035ed/artifacts/7z7a6zvg_149991.png";

export const PHONES = ["347-785-5458", "347-376-2708"];
export const PHONE_DIGITS = ["13477855458", "13473762708"];
export const WHATSAPP_PRIMARY = "13477855458";

export const HERO_IMG =
  "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBwcmlzdGluZSUyMGxpdmluZyUyMHJvb20lMjBsdXh1cnl8ZW58MHx8fHwxNzgxMTgyOTk3fDA&ixlib=rb-4.1.0&q=85";
export const ABOUT_IMG =
  "https://images.unsplash.com/photo-1613545325268-9265e1609167?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBwcmlzdGluZSUyMGxpdmluZyUyMHJvb20lMjBsdXh1cnl8ZW58MHx8fHwxNzgxMTgyOTk3fDA&ixlib=rb-4.1.0&q=85";
export const PROCESS_IMG =
  "https://images.unsplash.com/photo-1763026227930-ec2c91d4e7f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmluZyUyMHNlcnZpY2UlMjBzcHJheSUyMGJvdHRsZXxlbnwwfHx8fDE3ODExODI5OTd8MA&ixlib=rb-4.1.0&q=85";

export const SERVICE_ICON_KEYS = {
  regular: "home",
  deep: "sparkles",
  apartment: "building",
  office: "briefcase",
  move_in_out: "truck",
  post_construction: "hard-hat",
};
